module.exports = __webpack_public_path__ + "static/img/playerMsg.b78a6d31.svg";